export const MOXFIELD = "moxfield";
export const TCGPLAYER = "tcgplayer";
export const DELVERSCAN = "delverscan";

export const AVAILABLE_PLATFORMS = [MOXFIELD, TCGPLAYER, DELVERSCAN];
